(function () {
  class SetaraProgressSlider {
    constructor(root) {
      this.root = root;
      this.track = root.querySelector('[data-sps-track]');
      this.slides = Array.from(root.querySelectorAll('[data-sps-slide]'));
      this.dots = Array.from(root.querySelectorAll('[data-sps-dot]'));
      this.fills = Array.from(root.querySelectorAll('[data-sps-fill]'));

      if (!this.track || this.slides.length === 0) return;

      this.count = this.slides.length;
      this.index = 0;
      this.speed = (parseInt(root.dataset.speed, 10) || 5) * 1000;
      this.autoplay = root.dataset.autoplay === 'true' && this.count > 1;
      this.timer = null;

      this.onDotClick = this.onDotClick.bind(this);
      this.dots.forEach((dot) => dot.addEventListener('click', this.onDotClick));

      this.show(0, false);
      if (this.autoplay) this.play();
    }

    destroy() {
      this.pause();
      this.dots.forEach((dot) => dot.removeEventListener('click', this.onDotClick));
    }

    onDotClick(event) {
      const index = parseInt(event.currentTarget.dataset.spsDot, 10);
      if (Number.isNaN(index)) return;
      this.show(index, true);
      if (this.autoplay) this.play();
    }

    show(index, animate) {
      this.index = ((index % this.count) + this.count) % this.count;
      this.track.classList.toggle('sps__track--animate', animate);
      this.track.style.transform = 'translate3d(-' + this.index * 100 + '%, 0, 0)';
      this.updateUI();
    }

    next() {
      this.show(this.index + 1, true);
      if (this.autoplay) this.play();
    }

    play() {
      this.pause();
      this.runFill();
      this.timer = window.setTimeout(() => this.next(), this.speed);
    }

    pause() {
      if (this.timer) {
        window.clearTimeout(this.timer);
        this.timer = null;
      }
    }

    runFill() {
      this.fills.forEach((fill, i) => {
        fill.style.transition = 'none';
        fill.style.transform = i < this.index ? 'scaleX(1)' : 'scaleX(0)';
      });

      const fill = this.fills[this.index];
      if (!fill) return;

      fill.offsetHeight;
      fill.style.transition = 'transform ' + this.speed + 'ms linear';
      fill.style.transform = 'scaleX(1)';
    }

    updateUI() {
      this.slides.forEach((slide, i) => {
        const active = i === this.index;
        slide.classList.toggle('is-active', active);
        slide.setAttribute('aria-hidden', active ? 'false' : 'true');
      });

      this.dots.forEach((dot, i) => {
        const active = i === this.index;
        const complete = i < this.index;
        dot.classList.toggle('is-active', active);
        dot.classList.toggle('is-complete', complete);
        dot.setAttribute('aria-selected', active ? 'true' : 'false');
      });

      if (!this.autoplay) {
        this.fills.forEach((fill, i) => {
          fill.style.transition = 'none';
          fill.style.transform = i <= this.index ? 'scaleX(1)' : 'scaleX(0)';
        });
      }
    }
  }

  const instances = new WeakMap();
  const mobileHeightQuery = window.matchMedia('(max-width: 749px)');

  function syncMobileSliderHeight() {
    if (!mobileHeightQuery.matches) {
      document.documentElement.style.removeProperty('--sps-mobile-height');
      return;
    }

    const header = document.querySelector('.section-header');
    const announcement = document.querySelector('.announcement-bar-section');
    let topOffset = 0;

    if (announcement) topOffset += announcement.offsetHeight;
    if (header) topOffset += header.offsetHeight;

    document.documentElement.style.setProperty('--sps-mobile-height', `calc(100svh - ${topOffset}px)`);
  }

  function boot(scope) {
    scope.querySelectorAll('[data-sps]').forEach((root) => {
      const prev = instances.get(root);
      if (prev) {
        prev.destroy();
        instances.delete(root);
      }

      const slider = new SetaraProgressSlider(root);
      if (slider.track) instances.set(root, slider);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => {
      syncMobileSliderHeight();
      boot(document);
    });
  } else {
    syncMobileSliderHeight();
    boot(document);
  }

  window.addEventListener('resize', syncMobileSliderHeight);
  mobileHeightQuery.addEventListener('change', syncMobileSliderHeight);

  document.addEventListener('shopify:section:load', (event) => {
    syncMobileSliderHeight();
    boot(event.target);
  });
  document.addEventListener('shopify:section:unload', (event) => {
    event.target.querySelectorAll('[data-sps]').forEach((root) => {
      const slider = instances.get(root);
      if (slider) {
        slider.destroy();
        instances.delete(root);
      }
    });
  });
})();
